var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"file-menu"},[_c('div',{staticClass:"file-menu-item",on:{"click":_vm.openRoadmap}},[_c('div',{staticClass:"file-menu-item-text"},[_vm._v("Roadmap")])]),_c('div',{staticClass:"file-menu-item",on:{"click":_vm.openChat}},[_c('div',{staticClass:"file-menu-item-text"},[_vm._v("Give feedback")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }